function sanitizeForSearch(value) {
  if (!value) return ''

  return value?.toLowerCase().replaceAll(/[-]/g, '')
}

export default sanitizeForSearch
